import React, { useState, useEffect } from "react";
import { Modal, Spinner } from "react-bootstrap";
import {
  getShiftApi,
  getShiftListApi,
  gettripoptiondata,
  upadteTripTimeApi,
  updatetrip,
} from "../../../services/TransportService";
import { getShiftListSearchApi } from "../../../services/SearchService";
import { toast } from "react-toastify";
import Select from "react-select";

// --- Helper Functions ---
const formatTo12Hour = (timeStr) => {
  const [hour, minute] = timeStr?.split(":").map(Number);
  const ampm = hour >= 12 ? "PM" : "AM";
  const hour12 = hour % 12 === 0 ? 12 : hour % 12;
  return `${hour12}:${String(minute).padStart(2, "0")} ${ampm}`;
};

const addMinutes = (timeStr, minsToAdd) => {
  const [hours, minutes] = timeStr.split(":").map(Number);
  const date = new Date();
  date.setHours(hours);
  date.setMinutes(minutes + minsToAdd);
  return date.toTimeString().slice(0, 5);
};

const isTimeWithinRange = (time, min, max) => {
  console.log(time, min, max);
  const [h, m] = time.split(":").map(Number);
  const [minH, minM] = min.split(":").map(Number);
  const [maxH, maxM] = max.split(":").map(Number);

  const toMinutes = (h, m) => h * 60 + m;

  const timeMins = toMinutes(h, m);
  const minMins = toMinutes(minH, minM);
  const maxMins = toMinutes(maxH, maxM);

  return timeMins >= minMins && timeMins <= maxMins;
};

const Edittriptime = ({
  modalopen,
  setModalopen,
  routeid,
  tripdata,
  end_time,
  handleListReload,
}) => {
  const [timemsg, setTimemsg] = useState("");
  const [createtriploading, setCreatettriploading] = useState(false);
  const [triperrormsg, setTriperrormsg] = useState("");
  const [shiftoption, setShiftoption] = useState([]);
  const [selecetdShift, setSelectedShift] = useState(null);
  const [starttime, setStarttime] = useState("");
  const [endtime, setEndtime] = useState("");
  const [timeConfirmed, setTimeConfirmed] = useState(false);
  const [tripform, settripform] = useState({
    start_time: "",
  });
  const [errorform, setErrorform] = useState({
    start_time: "",
  });
  useEffect(() => {
    if (modalopen) {
      getShiftListApi()
        .then((res) => {
          const shiftList = res?.data || [];
          setShiftoption(shiftList);
          const selected = shiftList.find((d) => d?.id == tripdata?.shift?.id);
          if (selected) {
            setSelectedShift({ label: selected.name, value: selected.id });
          }

          const initialStartTime = tripdata?.start_time?.slice(0, 5) || "";

          setTimeConfirmed(!!tripdata?.start_time);
          setStarttime(initialStartTime);
          setEndtime(addMinutes(initialStartTime, 25));
          settripform({
            start_time: initialStartTime,
          });
          if (tripdata?.shift?.id && tripdata?.trip_mode) {
            const min =
              tripdata?.trip_mode === "PICKUP"
                ? selected?.start_time
                : selected?.drop_start_time;

            const max =
              tripdata?.trip_mode === "PICKUP"
                ? selected?.end_time
                : selected?.drop_end_time;

            if (min && max) {
              setTimemsg(`(${formatTo12Hour(min)} - ${formatTo12Hour(max)})`);
            } else {
              setTimemsg("");
            }
          } else {
            setTimemsg("");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      resettripform();
    }
  }, [modalopen, tripdata]);

  useEffect(() => {
    settripform((prev) => ({
      ...prev,
      start_time: starttime || "",
    }));
  }, [starttime]);

  const resettripform = () => {
    setStarttime("");
    setEndtime("");
    setTimemsg("");
    setTimeConfirmed(false);
    setTriperrormsg("");
    settripform({
      start_time: "",
    });
    setErrorform({
      start_time: "",
    });
  };

  const handletripform = () => {
    let valid = true;
    const error = {
      start_time: "",
    };
    if (!tripform?.start_time) {
      error.start_time = "Mandatory Field";
      valid = false;
    }
    setErrorform(error);
    if (valid) {
        setCreatettriploading(true);
        upadteTripTimeApi(routeid,{ ...tripform, trip_id: tripdata?.id,update_type:'CHANGE_TIME' })
          .then(() => {
            setModalopen(false);
            handleListReload();
            toast.success("Trip updated successfully");
          })
          .catch((err) => {
            setTriperrormsg(
              err?.response?.data?.message ||
                err?.response?.data?.error ||
                "Please try again later"
            );
          })
          .finally(() => setCreatettriploading(false));
    }
  };
  const getTripStartTimeMinRange = () => {
    const currentShift = shiftoption.find(
      (item) => item.id === tripdata?.shift?.id
    );
    if (!currentShift) return;
    if (tripdata?.trip_mode === "PICKUP") {
      return currentShift?.start_time;
    } else {
      return currentShift?.drop_start_time;
    }
  };

  const getTripStartTimeMaxRange = () => {
    const currentShift = shiftoption.find(
      (item) => item.id === tripdata?.shift?.id
    );
    if (!currentShift) return;
    if (tripdata?.trip_mode === "PICKUP") {
      return currentShift?.end_time;
    } else {
      return currentShift?.drop_end_time;
    }
  };
  return (
    <Modal
      show={modalopen}
      onHide={() => setModalopen(false)}
      dialogClassName="modal-top"
      size="md"
    >
      <Modal.Header closeButton>
        <Modal.Title>Change Time</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="p-2">
          {triperrormsg && (
            <div className="alert alert-danger">{triperrormsg}</div>
          )}
          <div>
            <label className="form-label">Start Time {timemsg}</label>
            <input
              type="time"
              className="form-control"
              value={starttime}
              min={getTripStartTimeMinRange()}
              max={getTripStartTimeMaxRange()}
              onChange={(e) => {
                const value = e.target.value;
                setStarttime(value); // Just update time on change
                setTimeConfirmed(false); // mark as unconfirmed
                if (value) {
                  setErrorform({ ...errorform, start_time: "" });
                }
              }}
              onBlur={() => {
                const min = getTripStartTimeMinRange();
                const max = getTripStartTimeMaxRange();

                if (!isTimeWithinRange(starttime, min, max)) {
                  setTriperrormsg(
                    `Start time must be between ${formatTo12Hour(
                      min
                    )} and ${formatTo12Hour(max)}`
                  );
                  setStarttime("");
                  setEndtime("");
                  return;
                } else {
                  setTriperrormsg("");
                  setEndtime(
                    addMinutes(starttime, parseFloat(end_time || "0"))
                  );
                }

                if (starttime) setTimeConfirmed(true);
              }}
            />
            {errorform?.start_time && (
              <small className="text-danger">{errorform.start_time}</small>
            )}
          </div>
          <div className="mt-2">
            <label className="form-label">End Time</label>
            <input
              type="time"
              className="form-control"
              value={endtime}
              readOnly
              disabled
            />
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <div className="d-flex w-100 justify-content-center gap-2">
          <button
            className="btn btn-outline-secondary"
            onClick={() => setModalopen(false)}
            disabled={createtriploading}
          >
            Cancel
          </button>
          <button
            className="btn btn-primary"
            onClick={handletripform}
            disabled={createtriploading}
          >
            {createtriploading && <Spinner animation="border" size="sm" />}{" "}
            Submit
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default Edittriptime;
